import React from 'react';

import Link from '@components/link/Link.tsx';
import setSpacesInText from '@functions/setSpacesInText.ts';

import ArticlePreviewI from './types.ts';

import renderFoot from './renders/renderFoot.tsx';
import renderHead from './renders/renderHead.tsx';

class ArticlePreview
    extends React.Component<ArticlePreviewI['props'], ArticlePreviewI['state']>
    implements ArticlePreviewI
{
    parent: ArticlePreviewI['parent'];

    constructor(props: ArticlePreviewI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    renderHead = renderHead;
    renderFoot = renderFoot;

    render() {
        const { article } = this.props;

        return (
            <Link
                className={`publicBlogPreview ${article.isMain ? '_main' : ''}`}
                pageName="public-blog-inner"
                ids={{ 2: article.url }}
            >
                {article.preview.fullSrc && (
                    <img
                        src={article.preview.fullSrc}
                        alt=""
                        className="publicBlogPreview__image"
                    />
                )}

                <div className="publicBlogPreview__content _col">
                    {this.renderHead()}
                    <div
                        className="publicBlogPreview__title"
                        dangerouslySetInnerHTML={{ __html: setSpacesInText(article.title) }}
                    ></div>
                    {this.renderFoot()}
                </div>
            </Link>
        );
    }
}

export default ArticlePreview;
